import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { RefetchTranscriptContext } from '@/containers/Transcript/context';
import type { TranscriptPublishType, TranscriptionRevisionStatus } from '@/enums';
import { useSelectUser } from '@/store/selectors';

type MutationParams = {
  publishType?: TranscriptPublishType;
  statusId: Exclude<TranscriptionRevisionStatus, TranscriptionRevisionStatus.InQueue>;
};

export const useTranscriptEnhancementStateMutation = ({ transcriptId }: ITranscriptId) => {
  const refetch = useContext(RefetchTranscriptContext);
  const user = useSelectUser();

  const mutation = useMutation({
    mutationKey: [
      `put:transcripts/enhancements/state`,
      transcriptId,
      user?.id,
    ],
    mutationFn: (params: MutationParams) => {
      /*return apiClient.transcripts.enhancements.updateState({
        assigneeId: user.id,
        statusId: params.statusId,
        publishType: params.publishType,
        transcriptId,
      })
        .then(() => refetch());
        */
      return Promise.reject('Not implemented');
    },
  });

  return mutation;
};